import { singleton, inject } from "tsyringe"
import { SendAnalytics } from "@/services/SendAnalytics"
import { AwEvent } from "@/models/AwEvent"
import { AwEventStore } from "@/models/AwEventStore"
export interface IAnalytics {
  setUp(webid: number, identifierkey: number, url: string): void
  register(aw: AwEventStore, key: number): void
}
export class Analytics implements IAnalytics {
  private analyticsArray: AwEventStore[] = new Array()
  private url: string = ""
  private identifierKey: number = 0
  private webinarId: number = -1
  public setUp(webid: number, identifierkey: number, url: string) {
    this.url = url
    this.webinarId = webid
    this.identifierKey = identifierkey
  }
  public register(aw: AwEventStore, key: number) {
    if (key == this.identifierKey) {
      this.analyticsArray.push(aw)
      const event: AwEvent = {
        eventsStore: this.analyticsArray,
        webinarId: this.webinarId
      }
      SendAnalytics(event, this.url)
      this.analyticsArray = new Array()
    }
  }
}
export class MockAnalytics implements IAnalytics {
  private analyticsArray: AwEventStore[] = new Array()
  private url: string = ""
  private identifierKey: number = 0
  private webinarId: number = -1
  public setUp(webid: number, identifierkey: number, url: string) {
    this.url = url
    this.webinarId = webid
    this.identifierKey = identifierkey
  }
  public register(aw: AwEventStore, key: number) {
    if (key == this.identifierKey) {
      console.info(
        `Mock Widget Analytics Registered :: { event : ${aw.eventType} }`
      )
    }
  }
}

@singleton()
export class AnalyticsClient {
  private _client: IAnalytics
  constructor(@inject("AnalyticsService") public client: IAnalytics) {
    this._client = client
  }
  public setUp(webid: number, identifierkey: number, url: string) {
    this._client.setUp(webid, identifierkey, url)
  }
  public register(aw: AwEventStore, key: number) {
    this._client.register(aw, key)
  }
}
